import React from "react";
import ColorPicker from "../../Components/ColorPicker";
import Header from "../../Components/Header";
import { About } from "../../images";
import * as T from "../../Components/Typography";
import * as S from "./style";

export default function AboutUs() {
  return (
    <S.Wrapper>
      <ColorPicker />
      <S.Main>
        <S.Content1 style={{ height: "100vh" }}>
          <S.DivImg>
            <S.AboutImg src={About} alt="About" />
          </S.DivImg>
          <S.Describtion>
            <S.TitlePage>
              <S.HeadSpan>Me</S.HeadSpan>
              <T.PageHead1>
                <S.TitleSpan>About</S.TitleSpan>
                Me
              </T.PageHead1>
            </S.TitlePage>

            <T.H4>Front-End Developer</T.H4>
            <T.ParaPage>
              A highly inquisitive Front-End Developer born with a passion for
              research and problem-solving. <br /> I have a great love for
              teamwork. <br />A deep understanding of technologies geared
              towards optimum user experience.
              <br /> Follow all standards of professionalism.
            </T.ParaPage>
            <S.DivBtn>
              <a href="https://drive.google.com/file/d/1NDqBfAwAr-w6lWWfZGwkSBor95g1cbxw/view">
                View Resume
              </a>
            </S.DivBtn>
          </S.Describtion>
        </S.Content1>
      </S.Main>
      <Header />
    </S.Wrapper>
  );
}
